import memoizeOne from 'memoize-one';
import queryString from 'query-string';
import { di } from 'react-magnetic-di';
import { WORKLOG, COMMENTS, PermalinkType } from './constants.tsx';

type PermalinkTypeAndId = {
	permalinkType: string;
	permalinkId: string;
};
type PermalinkParameterType = (typeof PermalinkType)[keyof typeof PermalinkType];

export const memoizedPermalinkTypeAndId = memoizeOne(
	(searchString: string): PermalinkTypeAndId | null => {
		const params = queryString.parseUrl(searchString).query;
		if (params[PermalinkType.COMMENTS]) {
			return { permalinkType: COMMENTS, permalinkId: params[PermalinkType.COMMENTS] };
		}
		if (params[PermalinkType.WORKLOG]) {
			return { permalinkType: WORKLOG, permalinkId: params[PermalinkType.WORKLOG] };
		}

		return null;
	},
);

export const getPermalinkTypeAndId = () => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	return memoizedPermalinkTypeAndId(window.location.search);
};

export const getPermalinkStatus = (targetPermalinkType: string) => {
	const { permalinkId, permalinkType } = getPermalinkTypeAndId() || {};
	const hasPermalink = permalinkType === targetPermalinkType && permalinkId != null;

	return {
		hasPermalink,
		permalinkId: hasPermalink ? permalinkId : '',
	};
};

export const getUrlPermalinkParameter = (id: string, permalinkType: PermalinkParameterType) => {
	di(window);
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const pathName = window.location.pathname;
	let urlQueryParam = `?${permalinkType}=${id}`;

	// in backlogs/modal view, next-gen board view, or jsd queues view
	if (
		/\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/.test(pathName) ||
		/\/jira\/people\/.*\/boards\/.*/.test(pathName) ||
		pathName === '/secure/RapidBoard.jspa' ||
		(pathName.startsWith('/jira/software/projects/') && pathName.split('/')[5] === 'boards') ||
		(pathName.startsWith('/jira/servicedesk/projects/') && pathName.split('/')[5] === 'queues')
	) {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		const url = new URL(window.location.href);

		// delete the opposite to avoid doubling up param in url
		url.searchParams.delete(
			permalinkType === PermalinkType.WORKLOG ? PermalinkType.COMMENTS : PermalinkType.WORKLOG,
		);
		url.searchParams.set(permalinkType, id);
		urlQueryParam = url.search;
	}

	return urlQueryParam;
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports, @atlassian/eng-health/no-barrel-files/disallow-reexports
export { WORKLOG, COMMENTS, PermalinkType };
